import { Routes } from '@angular/router';

/**
 * DEV-ONLY route for the game-preview harness. In production builds this
 * file is swapped for `preview-routes.prod.ts` (an empty array) via
 * angular.json `fileReplacements`, so webpack never sees the `import()`
 * below and the entire harness chunk is excluded from the shipped bundle.
 */
export const PREVIEW_ROUTES: Routes = [
  {
    path: 'game-preview',
    loadChildren: () => import('./game-preview.module').then(m => m.GamePreviewModule)
  }
];
